import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NgxGaugeModule } from 'ngx-gauge';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ICategory } from '@web-nx-ng-tsc/data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'web-promo-shared-pattern-lib-model-tire-dateil',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    NgxGaugeModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './lib-model-tire-dateil.component.html',
  styleUrl: './lib-model-tire-dateil.component.scss',
})
export class LibModelTireDateilComponent {
  @Input() set data(value: any) {
    this.dataSignal.set(value);
  }

  @Input() set category(value: any) {
    this.categorySignal.set(value);
    this.loggingService.log('|||| categorySignal :: w=>', this.categorySignal());
  }

  @Input() set checkTire(value: ICategory) {
    // this.tire = value;
    this.tireCheck = value;
    this.loggingService.log('checkTire', value);
  }
  // @Output() OnClickOpenpopup = new EventEmitter();

  tireCheck!: ICategory;
  @Output() emitComparison = new EventEmitter();
  @Output() emitVideoLinkUrl = new EventEmitter();

  // inject
  private observer = inject(BreakpointObserver);
  private readonly loggingService = inject(LoggingService);
  public readonly replaceBucket = new ReplaceBucket();

  selectedTireSize = '';
  gaugeType: 'full' | 'semi' | 'arch' = 'semi';
  gaugeValue = 0;
  isMobileView = false;
  gaugeSize = signal<number>(120);

  dataSignal = signal<any>(undefined);
  categorySignal = signal<string>('tire');
  onChangesSignal = signal<string>('');

  brandID!: number;
  modelCurrent!: string;

  constructor() {
    this.observer.observe('(max-width: 600px)').subscribe((res) => {
      this.isMobileView = res.matches;
      this.loggingService.log('Mobile?', this.isMobileView);
      if (this.isMobileView) {
        this.gaugeSize.set(95);
      } else {
        this.gaugeSize.set(140);
      }
    });
  }

  addToComparison(event: any) {
    this.emitComparison.emit(event);
  }
  onClickVideoLinkUrl(link_url: string) {
    this.emitVideoLinkUrl.emit(link_url);
  }

  // clickPopup() {
  //   this.OnClickOpenpopup.emit('');
  // }
}
